export default __webpack_public_path__ + "static/moov_logo-abdef35579f8dc5065d5046ae50dc9d4.webp";